<div class="upload-item position-relative" [class.d-flex]="preview" [class.uploader]="true" [class.dragging]="isDragging" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
	<div class="d-block w-100 button-container" [ngClass]="{ 'ms-1': preview, responsive: responsive }">
		@if (documentType?.label) {
			<span>{{ documentType?.label }}</span>
		}

		<!-- Área de drag and drop -->
		@if (!readonly) {
			<div class="icon">
				<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round">
					<path
						d="M398.1 233.2c0-1.2.2-2.4.2-3.6 0-65-51.8-117.6-115.7-117.6-46.1 0-85.7 27.4-104.3 67-8.1-4.1-17.2-6.5-26.8-6.5-29.5 0-54.1 21.9-58.8 50.5C57.3 235.2 32 269.1 32 309c0 50.2 40.1 91 89.5 91H224v-80l-48.2 0 80.2-83.7 80.2 83.6-48.2.1v80h110.3c45.2 0 81.7-37.5 81.7-83.4 0-45.9-36.7-83.2-81.9-83.4z"
					/>
				</svg>
			</div>
			<div class="text">Arrastra y suelta los archivos aquí</div>
			<div class="allowed-formats">Documento PDF, JPEG, JPG, PNG (Máx. 60MB cada uno)</div>
			<div class="max-files-warning" style="color: red; font-size: 0.9rem; margin-top: 0.5rem">Máximo {{ maxFiles }} archivo(s)</div>
			<div class="or">o</div>
			<input #files type="file" multiple [accept]="clientType === 'PJ' ? '.pdf,.jpeg,.jpg,.png' : '.pdf,.jpeg,.jpg,.png,.tiff'" [name]="fieldId" [id]="fieldId" class="upload-input" hidden (change)="onFileChange($event)" />
			<div class="snapshot-button-container d-inline-flex">
				<button type="button" (click)="showSnapshotModal = true" [disabled]="!canAddMore">
					<img src="/assets/icons/svg/camera-icon.svg" alt="Ícone de máquina fotográfica" loading="lazy" />
				</button>
			</div>
			@if (documentType?.type === 2 && isMobile) {
				<span class="warning-message">
					{{ uploadComponentString.removeTheDocumentPlasticAndMakeAllDataLegible }}
				</span>
			}
			@if (documentType?.type === 1 && isMobile) {
				<span class="warning-message">
					{{ uploadComponentString.makeSureTheImageClearDoNotWearGlassesHatsAccessories }}
				</span>
			}
			<button type="button" [disabled]="isPending || !canAddMore" (click)="onBrowseClick(files)" [id]="documentType?.type" class="btn btn-secondary d-inline-flex align-items-center justify-content-center generic-button browse">
				@if (isPending) {
					<span class="spinner-border spinner-border-sm mb-0" role="status" aria-hidden="true"></span>
				}
				{{ isPending ? uploadComponentString.sending : 'Subir archivos' }}
			</button>
		}

		@if (uploadedFiles.length > 0) {
			<div class="files-counter">{{ uploadedSuccessfully }} de {{ uploadedFiles.length }} archivo(s) subidos ({{ maxFiles }} máx)</div>
		}

		<!-- Mensaje de error -->
		@if (errorMessage) {
			<div class="error-message">{{ errorMessage }}</div>
		}

		<!-- Lista de archivos subidos -->
		@if (uploadedFiles.length > 0) {
			<div class="files-list-below">
				@for (file of uploadedFiles; track file; let i = $index) {
					<div class="file-item" [class.uploading]="file.uploading" [class.success]="file.success && !file.uploading" [class.error]="!file.success && !file.uploading">
						<div class="file-item-content">
							@if (file.uploading) {
								<span class="spinner-border spinner-border-sm status-icon" role="status" aria-hidden="true"></span>
							}
							@if (file.success && !file.uploading) {
								<img class="status-icon" src="/assets/icons/svg/aviso-positivo.svg" alt="Éxito" loading="lazy" />
							}
							@if (!file.success && !file.uploading) {
								<img class="status-icon" src="/assets/icons/svg/aviso-negativo.svg" alt="Error" loading="lazy" />
							}
							<span class="file-name" [style.cursor]="file.name && !file.previewLoading ? 'pointer' : 'default'" [style.text-decoration]="file.name ? 'underline' : 'none'" (click)="file.name && !file.previewLoading && openPreviewModal(file)">{{ file.name }}</span>
							@if (file.previewLoading) {
								<div style="height: 4px; background: #e9ecef; border-radius: 2px; margin-top: 6px; overflow: hidden">
									@if (file.previewProgress !== null) {
										<div [style.width]="file.previewProgress + '%'" style="height: 100%; background: #007bff; transition: width 0.2s ease"></div>
									}
									@if (file.previewProgress === null) {
										<div style="height: 100%; width: 30%; background: #007bff; animation: indet 1.2s infinite"></div>
									}
								</div>
							}
							@if (!file.uploading && !readonly) {
								<button type="button" class="remove-button" (click)="removeFile(i)" aria-label="Eliminar archivo" [disabled]="isDeleting || file.deleting">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
										<line x1="18" y1="6" x2="6" y2="18"></line>
										<line x1="6" y1="6" x2="18" y2="18"></line>
									</svg>
								</button>
							}
							@if (file.deleting || isDeleting) {
								<div style="height: 4px; background: #e9ecef; border-radius: 2px; margin-top: 6px; overflow: hidden">
									<div style="height: 100%; width: 30%; background: #dc3545; animation: indet 1.2s infinite"></div>
								</div>
							}
						</div>
					</div>
				}
			</div>
		}

		@if (documentType?.type === 2 && !isMobile && !readonly) {
			<span class="warning-message">
				{{ uploadComponentString.removeDocumentPlasticAndMakeAllDataLegible }}
			</span>
		}

		@if (documentType?.type === 1 && !isMobile && !readonly) {
			<span class="warning-message">
				{{ uploadComponentString.makeImageClearGlassesHatsAccessories }}
			</span>
		}
	</div>
</div>

<!-- Modal de webcam -->
@if (showSnapshotModal) {
	<div class="rod-modal-content">
		<div class="rod-modal">
			<div class="close-button" (click)="closeModal()">
				<img src="/assets/icons/svg/close-modal.svg" alt="Fechar modal" loading="lazy" />
			</div>
			<div class="content snapshot-modal">
				<div class="inner-snapshot-section">
					<webcam class="webcam-element" [width]="webcamWidth" [height]="webcamHeight" [trigger]="triggerObservable" (imageCapture)="handleImage(documentType?.type, $event)"> </webcam>
					<button type="button" (click)="triggerSnapshot()">
						@if (isPending) {
							<span class="spinner-border spinner-border-sm mb-0" role="status" aria-hidden="true"></span>
						}
						<span>{{ isPending ? uploadComponentString.sending : uploadComponentString.takeAPicture }}</span>
					</button>
				</div>
			</div>
		</div>
	</div>
}

<!-- Modal de vista previa -->
@if (showPreviewModal) {
	<div class="rod-modal-content" style="z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 20px; box-sizing: border-box">
		<div class="rod-modal preview-modal" style="position: relative; width: 90vw; max-width: 1200px; max-height: 90vh; margin: auto; border-radius: 12px; background: white; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3); display: flex; flex-direction: column">
			<div class="close-button" (click)="closePreviewModal()" style="position: absolute; z-index: 10000; top: 15px; right: 15px; cursor: pointer">
				<img src="/assets/icons/svg/close-modal.svg" alt="Cerrar modal" loading="lazy" />
			</div>
			<!-- Título fijo -->
			<div style="padding: 20px 50px 10px 20px; flex-shrink: 0">
				<h3 style="text-align: center; margin: 0; font-size: clamp(0.9rem, 2vw, 1.2rem); word-break: break-word">{{ previewFileName }}</h3>
			</div>
			<!-- Contenedor con scroll para la imagen/PDF -->
			<div style="flex: 1; overflow: auto; display: flex; min-height: 0">
				<!-- Vista previa de imagen -->
				@if (previewFileType && previewFileType.startsWith('image/')) {
					<div style="width: 100%; padding: 10px 20px 20px 20px; display: flex; justify-content: center; align-items: flex-start">
						<img [src]="previewFileUrl" [alt]="previewFileName" style="max-width: 100%; height: auto; object-fit: contain; display: block; border-radius: 4px" />
					</div>
				}
				<!-- Vista previa de PDF -->
				@if (previewFileType === 'application/pdf' || (previewFileName && previewFileName.toLowerCase().endsWith('.pdf'))) {
					<div style="width: 100%; padding: 10px 20px 20px 20px">
						<iframe [src]="sanitizedPreviewFileUrl" type="application/pdf" style="width: 100%; height: 100%; min-height: 500px; border-radius: 4px; border: none"></iframe>
					</div>
				}
			</div>
		</div>
	</div>
}

<!-- Estilos responsivos para el modal -->
<style>
	.rod-modal-content {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
	}

	@media (max-width: 768px) {
		.preview-modal {
			width: 95vw !important;
			max-height: 95vh !important;
		}
		.preview-modal > div:first-of-type {
			padding: 15px 40px 10px 15px !important;
		}
		.preview-modal h3 {
			font-size: 0.85rem !important;
		}
		.preview-modal > div:last-of-type > div {
			padding: 10px 15px 15px 15px !important;
		}
		.preview-modal embed {
			min-height: 400px !important;
		}
		.preview-modal iframe {
			min-height: 400px !important;
		}
	}

	@media (max-width: 480px) {
		.preview-modal {
			width: 98vw !important;
			max-height: 98vh !important;
		}
		.preview-modal > div:first-of-type {
			padding: 12px 35px 8px 12px !important;
		}
		.preview-modal h3 {
			font-size: 0.75rem !important;
		}
		.preview-modal > div:last-of-type > div {
			padding: 8px 12px 12px 12px !important;
		}
		.preview-modal embed {
			min-height: 300px !important;
		}
		.preview-modal iframe {
			min-height: 300px !important;
		}
		.rod-modal-content {
			padding: 10px !important;
		}
	}
</style>
